import type { FC } from "react";

import { type CashbackComplaintStatus } from "@/src/cashback/CashbackCommonInterfaces";
import * as stylex from "@stylexjs/stylex";

import { type PropsWithStyleX, colors } from "../../../styles/tokens.stylex";
import type { IComplaintItemNew } from "./ComplaintItemNew";
import ComplaintItemNew from "./ComplaintItemNew";
import StatusLabel from "./StatusLabel";

export interface IComplaintNew extends PropsWithStyleX {
    complaints?: IComplaintItemNew[];
    statusType: CashbackComplaintStatus;
    status: string;
}

const ComplaintNew: FC<IComplaintNew> = (props) => (
    <div {...stylex.props(styles.complaintNew, props.styleX)}>
        {props.complaints?.map((item, key) => (
            <ComplaintItemNew {...item} key={key} />
        ))}
        <StatusLabel
            status={props.statusType}
            statusLabel={props.status}
            {...stylex.props(styles.statusLabel)}
        />
    </div>
);

const styles = stylex.create({
    complaintNew: {
        paddingBlock: "5px",
        paddingInline: "0",
        borderTopColor: colors.b_centas,
        borderTopStyle: "solid",
        borderTopWidth: 1,
    },

    statusLabel: {
        marginBottom: 5,
    },
});

export default ComplaintNew;
